"use strict";

var _defineProperty = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var __1 = require("../../..");

var form_1 = require("../../../form");

var style_1 = require("../style");

var LoginForm = function LoginForm(_ref) {
  var onSuccess = _ref.onSuccess,
      onSubmit = _ref.onSubmit;

  var _react_1$useState = react_1.useState({
    email: '',
    password: ''
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      fields = _react_1$useState2[0],
      setFields = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      error = _react_1$useState4[0],
      setError = _react_1$useState4[1];

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    onSubmit(fields).then(function (response) {
      return onSuccess(response);
    }).catch(function (error) {
      setError(true);
    });
  };

  return react_1.default.createElement("form", {
    onSubmit: handleSubmit
  }, error && react_1.default.createElement(style_1.Error, {
    role: "alert"
  }, "Incorrect e-mail or password."), react_1.default.createElement(form_1.Wrapper, {
    label: "E-mail",
    name: "email"
  }, react_1.default.createElement(form_1.Input, {
    type: "email",
    name: "email",
    onChange: function onChange(field) {
      return setFields(Object.assign(Object.assign({}, fields), _defineProperty({}, field.name, field.value)));
    }
  })), react_1.default.createElement(form_1.Wrapper, {
    label: "Password",
    name: "password"
  }, react_1.default.createElement(form_1.Input, {
    type: "password",
    name: "password",
    onChange: function onChange(field) {
      return setFields(Object.assign(Object.assign({}, fields), _defineProperty({}, field.name, field.value)));
    }
  })), react_1.default.createElement(__1.SubmitButton, {
    label: "Login"
  }));
};

exports.default = LoginForm;